import keys from './keys';
export var translations = {
  keys: keys
};